import { render, staticRenderFns } from "./BodyBook.vue?vue&type=template&id=688abd29"
import script from "./BodyBook.vue?vue&type=script&lang=js"
export * from "./BodyBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports